import React from "react";
import "./style.css";
import { JOB_MENUS } from "utils/constants";

export default function FooterMenu({ onChangePage, menuActive, userType }) {
  return (
    <div className="footer-container">
      {JOB_MENUS.map((menu, index) => {
        if (userType === 0 && menu.route === 0) return;
        return (
          <div
            className="footer-menu-item"
            onClick={() => {
              onChangePage(menu.route, menu.key);
            }}
          >
            <div className={`footer-menu-image ${index === menuActive ? "footer-menu-active" : ""}`}>{menu.icon}</div>
            <div style={{ fontSize: "clamp(12px, 3vw, 16px)" }}>{menu.label[userType]}</div>
          </div>
        );
      })}
    </div>
  );
}
